module.exports = __webpack_public_path__ + "static/SafetyCulture-5013b46a4674effde3d69ab0d331e3c3.jpg";